export default __webpack_public_path__ + "static/media/s_01.cd8b1fa3.PNG";